import type { RouteRecordRaw } from "vue-router";
import { APP_SETTINGS_ROUTES as SETTINGS } from "@/Generated/Routes/paths";

const payments: RouteRecordRaw[] = [
  {
    ...SETTINGS.payments.root,
    component: () => import("@/Views/settings/payments/index.vue"),
    meta: {
      sidebar: false,
      i18nTitle: "settings.payment_receipts-title",
    },
  },
  {
    ...SETTINGS.payments.detail.root,
    component: () => import("@/Views/settings/payments/MonthDetail.vue"),
    meta: {
      sidebar: false,
      i18nTitle: "settings.payment_receipts.details.title",
    },
  },
];

export default payments;
